import { render, staticRenderFns } from "./LoaderPic.vue?vue&type=template&id=ad4633d6&scoped=true&"
import script from "./LoaderPic.vue?vue&type=script&lang=js&"
export * from "./LoaderPic.vue?vue&type=script&lang=js&"
import style0 from "./LoaderPic.vue?vue&type=style&index=0&id=ad4633d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4633d6",
  null
  
)

export default component.exports